export enum DialogSizeEnum {
  EXTRA_SMALL = 'extra-small',
  SMALL = 'small',
  LARGE = 'large',
  AUTO = 'auto',
}
